import type { DateRange, Nullish } from '@witmetrics/utils';
import { currentDate } from '@witmetrics/utils/time';
import { theme } from '@/utils/theme';

type PartialRange = DateRange | [string, Nullish] | [Nullish, string];

export const classes = {
  formControl: 'shrink-0',
  paper: 'flex',
  panel: 'flex flex-col',
  buttonWrapper: 'flex gap-2 mt-1 px-6 pb-3',
  button: 'grow py-2 rounded-[12px] font-bold',
  buttonBackground:
    'bg-grad hover:bg-grad shadow-[0_6px_14px_-8px_rgba(241,90,43,0.35)]',
  resetButton: 'py-2 px-4 rounded-[12px] font-bold',
  resetBorder: 'border-black/10 hover:border-black/20',
  resetText: 'text-taupe-2',
};

export const styles = {
  popover: {
    '& .MuiPaper-root': {
      marginTop: '0.25rem',
      borderRadius: theme.shape.rounded['2xl'],
    },
  },
};

export function isCalendarDay(target: EventTarget | null) {
  return (
    target instanceof HTMLElement && !!target.closest('.MuiDayCalendar-root')
  );
}

export function getInitialStart(value?: PartialRange | Nullish) {
  // If there's no start, default to today
  return value?.[0] || currentDate();
}

export function getInitialEnd(value?: PartialRange | Nullish): string {
  // Match the start when there's no end; default to today like the start
  return value?.[1] || value?.[0] || currentDate();
}
